export default "__VITE_ASSET__BrTwQObV__"